import React from 'react';
import { StyledMainContent } from "./MainContent.styles";

export const MainContent: React.FC = (props) => {
    return <StyledMainContent {...props}/>
};
